// Swiper - Main Slider
var $sliderSwiper = $('.mainSliderSwiper');

if ($sliderSwiper.length) {
  var mainSlideCount = $sliderSwiper.find('.swiper-slide').length;
  var mainMaxSlidesPerView = 1;

  let sliderSwiper = new Swiper('.mainSliderSwiper', {
      direction: 'horizontal',
      touchRatio: 1,
      loop: mainSlideCount > mainMaxSlidesPerView * 2,
      effect: 'fade',
      observer: true,
      observeParents: true,

      fadeEffect: {
          crossFade: true
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      keyboard: {
          enabled: true,
          onlyInViewport: true,
      },
      a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
      },
      on: {
        init: function () {
          if (this.isLocked) {
            $sliderSwiper.find('.swiper-button-next, .swiper-button-prev').hide();
          }
        }
      }
  });
}

// Slider with banner
new Swiper('.sliderBannerSwiper', {
    loop: true,
    pagination: {
        el: '.sliderBannerSwiper .swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.sliderBannerSwiper .swiper-button-next',
        prevEl: '.sliderBannerSwiper .swiper-button-prev',
    },
});


// Banner With Products
var $bannerProductsSwiper = $('.bannerProductsSwiper');

if ($bannerProductsSwiper.length) {
    var bannerSlideCount = $bannerProductsSwiper.find('.swiper-slide').length;
    var bannerMaxSlidesPerView = 4;

    new Swiper('.bannerProductsSwiper', {
      direction: 'horizontal',
      loop: true,
      slidesPerView: 2,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      spaceBetween: 5,
      observer: true,
      observeParents: true,

      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },

      breakpoints: {
        576: { slidesPerView: 2, spaceBetween: 5 },
        1024: { slidesPerView: 4, spaceBetween: 5 },
        1200: { slidesPerView: 4, spaceBetween: 5 },
        1400: { slidesPerView: 4, spaceBetween: 5 },
      },
      on: {
        init: function () {
          if (this.isLocked) {
            $bannerProductsSwiper.find('.swiper-button-next, .swiper-button-prev').hide();
          }
        }
      }
  });
}

// Popular categories
var $popularCategoriesSwiper = $('.popularCategoriesSwiper');

if ($popularCategoriesSwiper.length) {
    $popularCategoriesSwiper.each(function () {
      var desktopQuery = window.matchMedia('(min-width: 769px)');
      var popularCategoriesInstance = new Swiper(this, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 3,
      grabCursor: true,
      simulateTouch: true,
      touchStartPreventDefault: false,
      spaceBetween: 5,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      enabled: desktopQuery.matches,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },

      breakpoints: {
        0: { slidesPerView: 2, spaceBetween: 12 },
        576: { slidesPerView: 3, spaceBetween: 16 },
        768: { slidesPerView: 3, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
        1200: { slidesPerView: 4, spaceBetween: 20 },
        1400: { slidesPerView: 7, spaceBetween: 20 },
      },
      });

      desktopQuery.addEventListener('change', function (event) {
        if (event.matches) {
          popularCategoriesInstance.enable();
        } else {
          popularCategoriesInstance.disable();
        }
      });
    });
}

// var $recommendationsSwiper = $('.recommendationsSwiper');

// if ($recommendationsSwiper.length) {
//     var recommendationSlideCount = $recommendationsSwiper.find('.swiper-slide').length;
//     var recommendationMaxSlidesPerView = 4;

//     new Swiper('.recommendationsSwiper', {
//       direction: 'horizontal',
//       loop: true,
//       slidesPerView: 1,
//       autoplay: {
//         delay: 2500,
//         disableOnInteraction: false,
//         pauseOnMouseEnter: true,
//       },
//       spaceBetween: 15,
//       observer: true,
//       observeParents: true,

//       navigation: {
//         nextEl: '.recommendations-swiper-prev',
//         prevEl: '.recommendations-swiper-next',
//       },
//       a11y: {
//         enabled: true,
//         prevSlideMessage: 'Previous slide',
//         nextSlideMessage: 'Next slide',
//       },

//       breakpoints: {
//         576: { slidesPerView: 1, spaceBetween: 30 },
//         1024: { slidesPerView: 3, spaceBetween: 30 },
//         1200: { slidesPerView: 4, spaceBetween: 20 },
//         1400: { slidesPerView: 3, spaceBetween: 20 },
//       },
//       on: {
//         init: function () {
//           if (this.isLocked) {
//             $recommendationsSwiper.find('.swiper-button-next, .swiper-button-prev').hide();
//           }
//         }
//       }
//   });
// }

// Products Swiper
var $productsSwiper = $('.productsSwiper');

console.log('products', { $productsSwiper })

if ($productsSwiper.length) {
  $productsSwiper.each(function () {
    var $carousel = $(this);
    var isHomepageTouchCarousel = $carousel.hasClass('homepage-touch-carousel');
    var scrollbar = null;
    if (isHomepageTouchCarousel) {
      scrollbar = document.createElement('div');
      scrollbar.className = 'swiper-scrollbar';
      this.appendChild(scrollbar);
    }

    new Swiper(this, {
    direction: 'horizontal',
    loop: !isHomepageTouchCarousel,
    slidesPerView: 2,
    grabCursor: true,
    simulateTouch: true,
    touchStartPreventDefault: false,
    spaceBetween: 15,
    observer: true,
    observeParents: true,
    watchOverflow: true,
    scrollbar: scrollbar ? { el: scrollbar, draggable: true } : undefined,

    navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
    },
    a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
    },

    breakpoints: {
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1400: {
            slidesPerView: 4,
            spaceBetween: 20,
        }
    },
    });
  });
}

// Blog Swiper
var $blogSwiper = $('.blogSwiper');

if ($blogSwiper.length) {
  var blogSlideCount = $blogSwiper.find('.swiper-slide').length;
  var blogMaxSlidesPerView = 3;

  let blogSwiper = new Swiper('.blogSwiper', {
      direction: 'horizontal',
      loop: blogSlideCount > blogMaxSlidesPerView * 2,
      slidesPerView: 1,
      observer: true,
      observeParents: true,

      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 10
        }
      },
      on: {
        init: function () {
          if (this.isLocked) {
            $blogSwiper.find('.swiper-button-next, .swiper-button-prev').hide();
          }
        }
      }
  });
}
